var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgregarCategoria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FAE7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.75001H10.36L10.2 6.25001C10.0963 5.95663 9.90387 5.70276 9.64945 5.52359C9.39503 5.34442 9.09118 5.24881 8.78 5.25001H6.5C6.10218 5.25001 5.72064 5.40805 5.43934 5.68935C5.15804 5.97066 5 6.35219 5 6.75001V13.25C5 13.6478 5.15804 14.0294 5.43934 14.3107C5.72064 14.592 6.10218 14.75 6.5 14.75H13.5C13.8978 14.75 14.2794 14.592 14.5607 14.3107C14.842 14.0294 15 13.6478 15 13.25V8.25001C15 7.85219 14.842 7.47066 14.5607 7.18935C14.2794 6.90805 13.8978 6.75001 13.5 6.75001ZM14 13.25C14 13.3826 13.9473 13.5098 13.8536 13.6036C13.7598 13.6973 13.6326 13.75 13.5 13.75H6.5C6.36739 13.75 6.24021 13.6973 6.14645 13.6036C6.05268 13.5098 6 13.3826 6 13.25V6.75001C6 6.6174 6.05268 6.49023 6.14645 6.39646C6.24021 6.30269 6.36739 6.25001 6.5 6.25001H8.78C8.88482 6.24974 8.98708 6.28242 9.07231 6.34343C9.15755 6.40444 9.22146 6.4907 9.255 6.59001L9.525 7.41001C9.55854 7.50932 9.62245 7.59558 9.70769 7.65659C9.79292 7.7176 9.89518 7.75028 10 7.75001H13.5C13.6326 7.75001 13.7598 7.80269 13.8536 7.89646C13.9473 7.99023 14 8.1174 14 8.25001V13.25Z",
    fill: "#8E24AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgregarCategoria);
export default __webpack_public_path__ + "static/media/agregarCategoria.3bf99fa2ce00da7e8d054abfaa75df16.svg";
export { ForwardRef as ReactComponent };